import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { InlineImageView } from "../tiptap-node/image-inline-node/InlineImageView";

export const InlineImage = Node.create({
  name: "inlineImage",

  inline: true,
  group: "inline",
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      width: { default: 16 },
      height: { default: 16 },
    };
  },

  parseHTML() {
    return [
      {
        tag: "img[data-inline-image]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "img",
      {
        ...HTMLAttributes,
        "data-inline-image": "true",
        style: `width:${HTMLAttributes.width}px; height:${HTMLAttributes.height}px; vertical-align:middle;`,
      },
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(InlineImageView);
  },
});
